import { useRef, type PointerEvent } from 'react';

export function PanelResizer({ axis, onResize, className = '' }: { axis: 'x' | 'y'; onResize(delta: number): void; className?: string }) {
  const start = useRef(0);
  const onPointerDown = (event: PointerEvent<HTMLDivElement>) => {
    start.current = axis === 'x' ? event.clientX : event.clientY;
    event.currentTarget.setPointerCapture(event.pointerId);
  };
  const onPointerMove = (event: PointerEvent<HTMLDivElement>) => {
    if (!event.currentTarget.hasPointerCapture(event.pointerId)) return;
    const current = axis === 'x' ? event.clientX : event.clientY;
    const delta = current - start.current;
    start.current = current;
    onResize(delta);
  };
  return <div className={`panel-resizer panel-resizer-${axis} ${className}`} onPointerDown={onPointerDown} onPointerMove={onPointerMove} />;
}
